import { keepAll } from "./helpers";

export function formatCiteKey(
  component0: string,
  ...components: string[]
): string {
  return [component0, ...components].join(":");
}

export function formatEntry(
  entryType: string,
  citeKey: string,
  attributes: Array<[string, string | null | undefined]>,
): string {
  keepAll(attributes, niceAttribute);
  const keyWidth = Math.max(...attributes.map(([key, _value]) => key.length));
  const fmtAttributes = attributes
    .map(([key, value]) => `  ${key.padEnd(keyWidth)} = {${value}}`)
    .join(",\n");
  return `@${entryType}{${citeKey},\n${fmtAttributes}\n}`;
}

function niceAttribute(
  attr: [string, string | undefined | null],
): attr is [string, string] {
  return !!attr[1];
}
